import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { useAuth } from "@/contexts/AuthContext";
import { useCoordinatedAgents } from "@/hooks/useCoordinatedAgents";

interface CoordinatorStatus {
  isCoordinator: boolean;
  hasCoordinator: boolean;
}

export function useCoordinatorStatus(): CoordinatorStatus {
  const { user, activeWorkspaceId } = useAuth();
  const { data: rows, isLoading } = useCoordinatedAgents();
  const isCoordinator = (rows || []).some((r) => r.coordinator_user_id === user?.id);

  const { data: hasCoordinator = false } = useQuery({
    queryKey: ["has-coordinator", user?.id ?? null, activeWorkspaceId ?? null],
    enabled: Boolean(user?.id && activeWorkspaceId) && !isLoading && !isCoordinator,
    queryFn: async () => {
      const { data: agentRows } = await supabase
        .from("agents" as never)
        .select("coordinator_user_id")
        .eq("user_id", user!.id)
        .eq("organization_id", activeWorkspaceId)
        .eq("is_support_agent", false)
        .limit(1);
      const myAgent = (agentRows as { coordinator_user_id: string | null }[] | null)?.[0];
      return !!myAgent?.coordinator_user_id;
    },
  });

  return { isCoordinator, hasCoordinator: !isCoordinator && hasCoordinator };
}
